import { features } from "@/mocks/homeData";

export default function Features() {
  return (
    <section id="features" className="scroll-mt-24 bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-8 max-w-6xl mx-auto">
        <div className="max-w-2xl">
          <p className="font-label text-sm text-primary-600 font-medium">核心作用</p>
          <h2 className="mt-2 font-heading font-bold text-2xl md:text-3xl text-foreground-950 leading-snug">
            这个小页面，帮你解决六件事
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base">
            围绕「找得到、记得住、防走丢」三个关键词，本页把入口指引、地址同步、收藏方法与安全提醒放在一起，
            让你每次都能快速找到需要的部分。
          </p>
        </div>

        <div className="mt-8 md:mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {features.map((item) => (
            <article
              key={item.title}
              className="group rounded-lg border border-background-200 bg-background-50 p-5 md:p-6 transition-colors hover:border-primary-300"
            >
              <div className="flex items-center justify-between">
                <div className="w-11 h-11 flex items-center justify-center rounded-md bg-primary-100 text-primary-700 text-xl group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                  <i className={item.icon} />
                </div>
                <span className="px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-900 text-[11px] font-label">
                  {item.tag}
                </span>
              </div>
              <h3 className="mt-4 font-heading font-bold text-lg text-foreground-950">{item.title}</h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}